import { parse } from 'query-string'

import { useLocation } from 'react-router-dom'
import RedirectAppText from '../components/RedirectAppText'
import useCompany from '../data/use-company'
import { useRedirectAppTextWrapperVenueQuery } from '../graphql'
import getRedirectApp from '../utils/get-redirect-app'

interface Props {
  hasCustomRedirect: boolean
}

const RedirectAppTextWrapper = ({ hasCustomRedirect }: Props) => {
  const location = useLocation()
  const redirectApp = getRedirectApp(location)
  const { venueId } = parse(location.search) as { venueId: string }
  const { data: venueData } = useRedirectAppTextWrapperVenueQuery({
    variables: { id: venueId },
    skip: !venueId,
  })
  const { data: companyData } = useCompany()

  const venueName =
    venueData?.venue?.name ?? companyData?.company.widgetBrandSettings.displayName ?? companyData?.company?.name

  return <RedirectAppText redirectApp={redirectApp} venueName={venueName} hasCustomRedirect={hasCustomRedirect} />
}

export default RedirectAppTextWrapper
